import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { ServerSideDataLoader, PaginationInfo, Enum, IEnumTranslator } from "uicomponents";
import { BillsListView } from "./billsList-view"
import { translate } from "src/common/utilities";

export class BillsListViewModel extends WindowViewModel implements IPopup {
    public getTitle(): string {
        return translate("billsList-viewModel.receiptsAndRemittancesList", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.bills = ObservableArray.create<Bill>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.billTypeEnumProvider = new billTypeEnumProvider();
        this.refresh();
    }

    closePopup(resultCode: string) { }
    GetDefaultView(): View<ViewModel> {
        return new BillsListView();
    }
    public getTypeId(): string {
        return "VM-9E5D50BA-FA95-4E33-A8F5-1E41F2282FBE"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set bills(v: ObservableArray<Bill>) { this._bills = v; } public get bills(): ObservableArray<Bill> { return this._bills; } private _bills: ObservableArray<Bill>;
    public set billTypeEnumProvider(v: billTypeEnumProvider) { this._billTypeEnumProvider = v; } public get billTypeEnumProvider(): billTypeEnumProvider { return this._billTypeEnumProvider; } private _billTypeEnumProvider: billTypeEnumProvider;

    refresh() {
        this.loader.refresh();
    }

    protected updateFilteringInformation(filteringInformation: any) {
        return filteringInformation;
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryServices/GetAllBills', {
                FurtherQueryInfo: this.updateFilteringInformation(filteringInformation)
            });
            this.bills.update(...result.Bills.map(x => {
                let r = new Bill(this);
                r.billId = x.Id;

                r.billTime = x.Time;
                r.billCode = x.No;
                r.warehouseName = x.WarehouseName;
                r.partyName = x.PartyName;

                r.billType = x.Type;
                r.operationType = x.OperationType;
                r.operationNo = x.OperationNo;

                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async showBill(bill: Bill) {
        let selectedBill = new DetailedBill(this);
        selectedBill.loadByBillId(bill.billId)
        await this.showPopup(selectedBill);

    }
}

export class billTypeEnumProvider extends Enum implements IEnumTranslator {

    constructor() {
        super();
        this.translator = this;
        this.values = [1, 2, 3, 4];
    }
    GetString(value: any) {
        return new TranslatorConverter().requestBillTypeNameConverter(value);
    }
}

export class Bill extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: BillsListViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent: BillsListViewModel;

    public set billId(v: string) { this._billId = v; } public get billId(): string { return this._billId; } private _billId: string;
    public set billTime(v: moment.Moment) { this._billTime = v; } public get billTime(): moment.Moment { return this._billTime; } private _billTime: moment.Moment;
    public set billCode(v: string) { this._billCode = v; } public get billCode(): string { return this._billCode; } private _billCode: string;
    public set billType(v: number) { this._billType = v; } public get billType(): number { return this._billType; } private _billType: number;
    public set operationType(v: number) { this._operationType = v; } public get operationType(): number { return this._operationType; } private _operationType: number;
    public set operationNo(v: string) { this._operationNo = v; } public get operationNo(): string { return this._operationNo; } private _operationNo: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set partyName(v: string) { this._partyName = v; } public get partyName(): string { return this._partyName; } private _partyName: string;

    edit() {
        this._typedParent.showBill(this);
    }
}

export class DetailedBill extends ViewModel implements IPopup {

    public getTypeId(): string { return 'detailedBill'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: BillsListViewModel) {
        super(parent);
        this._typedParent = parent;
        this.lineItems = ObservableArray.create<LineItem>();
    }
    closePopup(resultCode: string = null) { }
    private _typedParent: BillsListViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time; } private _time: moment.Moment;
    public set no(v: string) { this._no = v; } public get no(): string { return this._no; } private _no: string;
    public set billType(v: number) { this._billType = v; } public get billType(): number { return this._billType; } private _billType: number;
    public set operationType(v: number) { this._operationType = v; } public get operationType(): number { return this._operationType; } private _operationType: number;
    public set operationNo(v: string) { this._operationNo = v; } public get operationNo(): string { return this._operationNo; } private _operationNo: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set partyName(v: string) { this._partyName = v; } public get partyName(): string { return this._partyName; } private _partyName: string;
    public set lineItems(v: ObservableArray<LineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<LineItem> { return this._lineItems; } private _lineItems: ObservableArray<LineItem>;

    async loadByBillId(id: string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryServices/GetBillDetail', {
                BillId: id
            });
            this.id = result.Id;
            this.time = moment.utc(result.Time);
            this.no = result.No;
            this.billType = result.Type;
            this.operationType = result.OperationType;
            this.operationNo = result.OperationNo;
            this.warehouseName = result.WarehouseName;
            this.partyName = result.PartyName;
            this.lineItems.update(...result.LineItems.map((x, i) => {
                let lineItem = new LineItem(this);
                lineItem.index = i + 1;
                lineItem.productName = x.ProductName;
                lineItem.productId = x.MeasuredProductId;
                lineItem.unitName = x.UnitName;
                lineItem.amount = x.Amount;
                lineItem.productCode = x.ProductCode;
                lineItem.description = x.Description;
                return lineItem;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class LineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId; } private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;

}
